export default "__VITE_ASSET__BxxVbdJo__"